import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';

const INSTANCE_ID_PARAM = 'instanceId';
const STEP_ID_PARAM = 'stepId';

export default function useSelectedFlowInstanceUrlState() {
	const [searchParams, setSearchParams] = useSearchParams();
	const selectedInstanceId = searchParams.get(INSTANCE_ID_PARAM);
	const selectedStepId = searchParams.get(STEP_ID_PARAM);

	const selectInstance = useCallback(
		(instanceId: string) => {
			setSearchParams((previous) => {
				const next = new URLSearchParams(previous);
				if (previous.get(INSTANCE_ID_PARAM) !== instanceId) next.delete(STEP_ID_PARAM);
				next.set(INSTANCE_ID_PARAM, instanceId);
				return next;
			}, { replace: false });
		},
		[setSearchParams],
	);

	const clearInstance = useCallback(() => {
		setSearchParams((previous) => {
			const next = new URLSearchParams(previous);
			next.delete(INSTANCE_ID_PARAM);
			next.delete(STEP_ID_PARAM);
			return next;
		}, { replace: false });
	}, [setSearchParams]);
	const selectStep = useCallback((stepId: string) => {
		setSearchParams((previous) => {
			const next = new URLSearchParams(previous);
			next.set(STEP_ID_PARAM, stepId);
			return next;
		}, { replace: true });
	}, [setSearchParams]);

	return {
		selectedInstanceId,
		selectedStepId,
		selectStep,
		selectInstance,
		clearInstance,
	};
}
